import { GOOGLE_API_KEY } from 'constants/ResourcesConstants'
import { encodeQueryData } from 'utils/Helpers'

export function getMapURL(lat, lng, width, height) {
  const query = {
    center: `${lat},${lng}`,
    key: GOOGLE_API_KEY,
    size: `${width}x${height}`,
    zoom: 12,
    style: 'element:labels|visibility:off&feature:administrative.neighborhood|visibility:off'
  }
  return `https://maps.googleapis.com/maps/api/staticmap?${encodeQueryData(query)}`
}

export function getMapByCity(city, width = 360, height = 200) {
  const query = {
    center: city,
    key: GOOGLE_API_KEY,
    size: `${width}x${height}`,
    zoom: 8,
    style: 'element:labels|visibility:off&feature:administrative.neighborhood|visibility:off'
  }
  return `https://maps.googleapis.com/maps/api/staticmap?${encodeQueryData(query)}`
}



// WEBPACK FOOTER //
// ./src/scripts/app/api/MapAPI.js